import { queryOptions } from "@tanstack/react-query";
import { backendService } from "@/lib/backend";
import { extractionWrapper } from "@/lib/backend/utils/extract";

export const queryOptions_myFriendCheck = () =>
	queryOptions({
		queryKey: ["friend-check", "my-friend-check"] as const,
		queryFn: (context) =>
			extractionWrapper(
				backendService.friendcheck.friendcheckControllerGetMyFriendCheck({
					signal: context.signal,
				}),
			),
	});
